import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d6dce3a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "full-sidebar d-flex flex-column" }
const _hoisted_2 = { class: "vrt-body" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "vrt-title" }, "Not a valid QR code", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "vrt-subtitle" }, " This trailer can still be selected through the manual entry screen. ", -1))
const _hoisted_5 = { class: "vrt-actions" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "vrt-footnote" }, " If the QR code you scanned is already attached to a Knight/Swift trailer, there may be association errors in the system. ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VirtualRedTagHeader = _resolveComponent("VirtualRedTagHeader")!
  const _component_SvgBrokenQr = _resolveComponent("SvgBrokenQr")!
  const _component_fbx_button = _resolveComponent("fbx-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_VirtualRedTagHeader),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createVNode(_component_SvgBrokenQr, { class: "vrt-icon" }),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_fbx_button, {
          "button-text": "Manual Entry",
          theme: "primary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('manualEntry')))
        }),
        _createVNode(_component_fbx_button, {
          "button-text": "Back to Home Screen",
          theme: "primaryOutline",
          class: "italic",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('backToWelcome')))
        })
      ]),
      _hoisted_6
    ])
  ]))
}